import React from "react";
import classes from './ServicesProgramsDocumet.module.scss'
import Document from "../../../../components/Document";
export default function ServicesProgramsDocumet() {
    return(
        <Document/>

    )
    
}